import { gql, useQuery } from "@apollo/client";

export function useGetPolicyList(organisationId: string = null) {
  return useQuery(
    gql`
      query getPolicyList($filter: FilterFindManyCompanyPolicyInput) {
        company_policies(filter: $filter) {
          _id
          name
          policy_file_name
          tags
          status
          created_by_user {
            _id
            name
          }
          created_at
          updated_by_user {
            _id
            name
          }
          updated_at
        }
      }
    `,
    {
      variables: {
        filter: {
          organisation_id: organisationId || undefined,
        }
      },
      fetchPolicy: "network-only",
    }
  );
}
